import axios from 'axios'
import { getAPIUrl } from '../API'

export interface SearchPropertyBySecurityEstateNameRequest {
  securityEstateName: string
  region: string
}

export interface SearchBySecurityEstateNameResponse {
  complex: string
  mun_name: string
  suburb: string
  region: string
}

export const searchPropertyBySecurityEstateName: (
  options: SearchPropertyBySecurityEstateNameRequest,
) => Promise<SearchBySecurityEstateNameResponse[]> = async (options) => {
  const { data } = await axios.post(
    `${getAPIUrl()}/BridgingFinance/searchpropertybysecurityestatename`,
    options,
    {
      headers: {
        Authorization: `Bearer ${await sessionStorage.getItem('jwt')}`,
      },
    },
  )
  if (!data.data) {
    alert(`No results found for security estate: ${options.securityEstateName}`)
  }
  return data.data
}
